/*
 * App.tsx
 * Main application component that sets up routing, header, and footer.
 * Uses React Helmet for managing head tags and Suspense for lazy-loading pages.
 */

import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { MentorModalProvider } from './contexts/MentorModalContext';
import Routes from './Routes';
import Header from './components/Header';
import './index.css';

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <MentorModalProvider>
          <div className="min-h-screen bg-background font-sans antialiased">
            <Header />
            <Routes />
          </div>
        </MentorModalProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
};

export default App;
